import gql from 'graphql-tag';

export default gql`
  mutation(
    $publicationUrl: URI!
    $suggestionsListId: ID!
    $position: Int!
    $among: Int!
  ) {
    addCollaborativeFilteringSuggestion(
      input: {
        publicationUrl: $publicationUrl
        suggestionsListId: $suggestionsListId
        libraryComment: ""
        position: $position
        among: $among
      }
    ) {
      code
    }
  }
`;
